import { Contact } from "../../service/contact";
import { columns } from "./columns";
import { DataTable } from "@/components/data-table/data-table";
import { exportDataToCsv } from "@/utils/exportToCsv";
import { Button } from "@/components/ui/button";

interface ContactsTableProps {
  contacts: Contact[];
}

export function ContactsTable({ contacts }: ContactsTableProps) {
  return (
    <div className="-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-x-12 lg:space-y-0">
      <DataTable
        tableId="root-user-contacts"
        data={contacts}
        searchColumn="name"
        searchPlaceholder="Filter contacts..."
        columns={columns}
        floatingActionItems={(table) => {
          const selectedCount = table.getSelectedRowModel().rows.length;
          const selectedRows = table
            .getSelectedRowModel()
            .rows.map((row) => row.original);
          return [
            <div
              key="selectedCount"
              className="text-muted-foreground mr-2 flex items-center text-sm"
            >
              {selectedCount} selected
            </div>,
            <Button
              key="export-csv"
              variant="default"
              size="sm"
              className="space-x-1"
              onClick={() => exportDataToCsv(selectedRows, "contacts.csv")}
            >
              <span>Export CSV</span>
            </Button>,
          ];
        }}
      />
    </div>
  );
}
